var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.458 12.458h1.584a1.584 1.584 0 001.583-1.583V7.708a1.583 1.583 0 00-1.583-1.583H2.958a1.583 1.583 0 00-1.583 1.583v3.167a1.583 1.583 0 001.583 1.583h1.584m1.583 3.167h4.75a1.583 1.583 0 001.583-1.583v-3.167a1.583 1.583 0 00-1.583-1.583h-4.75a1.583 1.583 0 00-1.583 1.583v3.167a1.584 1.584 0 001.583 1.583zm6.333-9.5V2.958a1.583 1.583 0 00-1.583-1.583h-4.75a1.583 1.583 0 00-1.583 1.583v3.167h7.916z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "static/media/printer.7f6f6fbe.svg";
export { SvgPrinter as ReactComponent };